import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { rf } from "../theme";
import { PushButton } from "../ui";
import BrandLogo from "../BrandLogo";

const NAV = [
  { label: "Cohorts", href: "#cohorts" },
  { label: "Curriculum", href: "#curriculum" },
  { label: "How a week runs", href: "#rhythm" },
  { label: "FAQ", href: "#faq" },
];

export const SiteHeader = ({ onPrimary }) => {
  const navigate = useNavigate();
  const [lifted, setLifted] = useState(false);

  useEffect(() => {
    const onScroll = () => setLifted(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        backgroundColor: lifted ? "rgba(249,231,216,0.92)" : "transparent",
        backdropFilter: lifted ? "blur(8px)" : "none",
        borderBottom: lifted ? rf.lineThin : "2px solid transparent",
        transition: "background-color 0.2s ease, border-color 0.2s ease",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, py: 1.75 }}>
          <BrandLogo size="medium" onClick={() => navigate("/reinforce")} />

          <Box
            component="nav"
            aria-label="Main"
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 0.5,
              px: 1,
              py: 0.5,
              backgroundColor: rf.paper,
              border: rf.lineThin,
              borderRadius: rf.radiusPill,
              boxShadow: rf.shadowSm,
            }}
          >
            {NAV.map((item) => (
              <Box
                key={item.href}
                component="a"
                href={item.href}
                sx={{
                  px: 1.75,
                  py: 0.75,
                  borderRadius: rf.radiusPill,
                  fontFamily: rf.display,
                  fontSize: 14.5,
                  fontWeight: 600,
                  color: rf.ink,
                  textDecoration: "none",
                  "&:hover": { backgroundColor: rf.creamDeep },
                }}
              >
                {item.label}
              </Box>
            ))}
          </Box>

          <PushButton variant="primary" onClick={onPrimary}>
            See cohorts
          </PushButton>
        </Box>
      </Container>
    </Box>
  );
};

export default SiteHeader;
